// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2Wwfg","alert":"SettungsInbox_alert__2ejyk"};